import {Component, DestroyRef, inject, OnInit} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {filter} from 'rxjs/operators';
import {ConsignmentType} from '|api/commons';
import {ReceivedDocumentDto} from '|api/document';
import {DocumentDetailService, OwnConsignmentOfficeDeskTableView, OwnConsignmentTableComponent} from '|shared';


@Component({
  selector: 'icz-document-detail-office-desk-consignments',
  templateUrl: './document-detail-office-desk-consignments.component.html',
  styleUrls: ['./document-detail-office-desk-consignments.component.scss'],
  imports: [OwnConsignmentTableComponent]
})
export class DocumentDetailOfficeDeskConsignmentsComponent implements OnInit {

  private documentDetailService = inject(DocumentDetailService);
  private destroyRef = inject(DestroyRef);

  readonly tableView = OwnConsignmentOfficeDeskTableView.OD_OFFICER_CREATE_OFFICE_DESK_CONSIGNMENTS;
  document!: ReceivedDocumentDto;

  readonly ConsignmentType = ConsignmentType;

  ngOnInit() {
    this.documentDetailService.object$.pipe(
      filter(Boolean),
      takeUntilDestroyed(this.destroyRef),
    ).subscribe(document => {
      this.document = document as unknown as ReceivedDocumentDto;
    });
  }

}
